class DescriptionClamp extends HTMLElement {
  #resizeObserver;

  connectedCallback() {
    this.content = this.querySelector('[ref="content"]');
    this.toggle = this.querySelector('[ref="toggle"]');
    if (!this.content || !this.toggle) return;

    this.toggle.addEventListener('click', this.#onToggle);
    this.#resizeObserver = new ResizeObserver(() => this.#update());
    this.#resizeObserver.observe(this.content);
    this.#update();
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    this.toggle?.removeEventListener('click', this.#onToggle);
  }

  #onToggle = () => {
    const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
    this.toggle.setAttribute('aria-expanded', String(!expanded));
    this.toggleAttribute('data-expanded', !expanded);
    this.toggle.querySelector('[ref="label"]').textContent = expanded
      ? this.dataset.moreLabel
      : this.dataset.lessLabel;
    this.#update();
  };

  #update() {
    const lines = Number(this.dataset.lines) || 7;
    const style = getComputedStyle(this.content.querySelector('.text-block') ?? this.content);
    const fontSize = parseFloat(style.fontSize);
    const lineHeight = parseFloat(style.lineHeight) || fontSize * 1.4;
    this.style.setProperty('--clamp-line-height', `${lineHeight}px`);

    // Measure with the clamp removed so the result is not affected by the current state.
    const wasClamped = !this.hasAttribute('data-expanded');
    this.setAttribute('data-measuring', '');
    const overflows = this.content.scrollHeight > lineHeight * lines + 1;
    this.removeAttribute('data-measuring');

    this.toggleAttribute('data-clamped', overflows && wasClamped);
    this.toggle.hidden = !overflows;
  }
}

if (!customElements.get('description-clamp')) {
  customElements.define('description-clamp', DescriptionClamp);
}
